import { Injectable } from '@angular/core';
import * as faker from 'faker/locale/pt_BR'

import { Alternativa } from '../Models/alternativa.model';
import { of, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AlternativaService {

  constructor(private http: HttpClient) { }

  obterAlternativas(perguntaId: number) {
    return this.mockAlternativas(perguntaId);
  }

  private mockAlternativas(perguntaId: number): Observable<Alternativa[]> {
    let alternativas = Array<Alternativa>();
    for (let index = 0; index < 5; index++) {
      let item = new Alternativa();
      item.alternativaid = faker.random.number({ min: 1, max: 20 });
      item.descricao = faker.lorem.lines(8);
      item.perguntaid = perguntaId;

      alternativas.push(item);
    }

    return of(alternativas);
  }
}
